import './Footer.scss';
import { connect } from 'react-redux';
import getLocaleStringsById from 'stores/selectors/getLocaleStringsById';
import getLocale from 'stores/selectors/getLocale';
import Footer from './Footer';

const mapStateToProps = (state) => {
  const {
    AA_Give_Feedback_Title,
    AA_Give_Feedback_Description,
    AA_Start_Survey,
    AA_Cookies_Notice,
    AA_Contact_Us,
    AA_Terms_And_Conditions,
    AA_Legal_Notices_Attribution,
    AA_Copyright_Notice,
  } = getLocaleStringsById(state);
  return {
    locale: getLocale(state),
    AA_Give_Feedback_Title,
    AA_Give_Feedback_Description,
    AA_Start_Survey,
    AA_Cookies_Notice,
    AA_Contact_Us,
    AA_Terms_And_Conditions,
    AA_Legal_Notices_Attribution,
    AA_Copyright_Notice,
  };
};

export default connect(mapStateToProps)(Footer);
